import type { FC } from "react";
import AccountPasswordCard from "../Components/AccountPasswordCard";
import AccountProfileCard from "../Components/AccountProfileCard";
import { useAccountSettings } from "../Hooks/UseAccountSettings";

const AccountSettings: FC = () => {
  const {
    t,
    isAdmin,
    isViewer,
    profileImage,
    firstName,
    setFirstName,
    lastName,
    setLastName,
    email,
    websiteUrl,
    setWebsiteUrl,
    industry,
    setIndustry,
    currency,
    setCurrency,
    supportedCurrencies,
    company,
    contactNumber,
    firstNameError,
    lastNameError,
    isUpdatingProfile,
    isUpdatingPassword,
    currentPassword,
    setCurrentPassword,
    newPassword,
    setNewPassword,
    confirmPassword,
    setConfirmPassword,
    passwordError,
    passwordStrength,
    isDirty,
    handleProfileUpdate,
    handlePhotoUpload,
    handleRemovePhoto,
    handlePasswordChange,
    warnAdminOnly,
  } = useAccountSettings();

  return (
    <div className="account-settings-container">
      <AccountProfileCard
        t={t}
        isAdmin={isAdmin}
        isViewer={isViewer}
        profileImage={profileImage}
        firstName={firstName}
        lastName={lastName}
        email={email}
        websiteUrl={websiteUrl}
        industry={industry}
        currency={currency}
        supportedCurrencies={supportedCurrencies}
        company={company}
        contactNumber={contactNumber}
        firstNameError={firstNameError}
        lastNameError={lastNameError}
        isUpdatingProfile={isUpdatingProfile}
        isDirty={isDirty}
        onFirstNameChange={setFirstName}
        onLastNameChange={setLastName}
        onWebsiteUrlChange={setWebsiteUrl}
        onIndustryChange={setIndustry}
        onCurrencyChange={setCurrency}
        onPhotoUpload={handlePhotoUpload}
        onRemovePhoto={handleRemovePhoto}
        onProfileUpdate={handleProfileUpdate}
        onAdminOnlyWarning={warnAdminOnly}
      />

      <AccountPasswordCard
        t={t}
        currentPassword={currentPassword}
        newPassword={newPassword}
        confirmPassword={confirmPassword}
        passwordError={passwordError}
        passwordStrength={passwordStrength}
        isUpdatingPassword={isUpdatingPassword}
        onCurrentPasswordChange={setCurrentPassword}
        onNewPasswordChange={setNewPassword}
        onConfirmPasswordChange={setConfirmPassword}
        onPasswordChange={handlePasswordChange}
      />
    </div>
  );
};

export default AccountSettings;
